import type { ID } from '@octopus-do/octopus-project-core'

import { fetchNest } from '@/nest'
import type {
  InboxPage,
  ProjectNotificationSettings,
  ProjectNotificationSettingsView,
  WorkspaceUnread,
} from './types'

// The inbox routes of octopus-api (OCT-5229). The published api client binds
// only what its buildClient lists, and these are not in it yet; once they
// are, this file becomes NestClient.notifications / projects.notifications.
export const inboxClient = {
  // every unread row of the workspace, one list
  fresh: (workspace: string) =>
    fetchNest<InboxPage>(
      `/notifications?${new URLSearchParams({ workspace, read: 'unread' })}`
    ),
  // the read rows, a page at a time, older than `before`
  earlier: (workspace: string, before: number | null) => {
    const query = new URLSearchParams({ workspace, read: 'read' })

    if (before !== null) {
      query.set('before', String(before))
    }

    return fetchNest<InboxPage>(`/notifications?${query}`)
  },
  unread: () => fetchNest<WorkspaceUnread[]>('/notifications/unread'),
  markRead: (ids: number[]) =>
    fetchNest<void>('/notifications/read', {
      method: 'PUT',
      body: JSON.stringify({ ids }),
    }),
  markAllRead: (workspace: string) =>
    fetchNest<void>(
      `/notifications/read-all?${new URLSearchParams({ workspace })}`,
      { method: 'PUT' }
    ),
  seen: (projectId: ID) =>
    fetchNest<void>(`/projects/${projectId}/notifications/seen`, {
      method: 'POST',
    }),
  getSettings: (projectId: ID) =>
    fetchNest<ProjectNotificationSettingsView>(
      `/projects/${projectId}/notification-settings`
    ),
  putSettings: (projectId: ID, body: ProjectNotificationSettings) =>
    fetchNest<ProjectNotificationSettingsView>(
      `/projects/${projectId}/notification-settings`,
      { method: 'PUT', body: JSON.stringify(body) }
    ),
}
